import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'myTeam', sv, true, true)
i18n.addResourceBundle('en', 'myTeam', en, true, true)

export function buildMyTeamRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/overview',
      component: lazyRouteComponent(
        () => import('./MyTeamOverviewPage'),
        'MyTeamOverviewPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/members',
      component: lazyRouteComponent(
        () => import('./MyTeamMembersPage'),
        'MyTeamMembersPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/handout',
      component: lazyRouteComponent(
        () => import('./MyTeamHandoutPage'),
        'MyTeamHandoutPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/invoices',
      component: lazyRouteComponent(
        () => import('./MyTeamInvoicesPage'),
        'MyTeamInvoicesPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/reports',
      component: lazyRouteComponent(
        () => import('./MyTeamReportsPage'),
        'MyTeamReportsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      // More specific path than `/my-team/reports/$reportId` — must be first.
      path: '/my-team/reports/new',
      component: lazyRouteComponent(
        () => import('./MyTeamReportCreatePage'),
        'MyTeamReportCreatePage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/reports/$reportId/edit',
      component: lazyRouteComponent(
        () => import('./MyTeamReportEditPage'),
        'MyTeamReportEditPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/reports/$reportId',
      component: lazyRouteComponent(
        () => import('./MyTeamReportDetailPage'),
        'MyTeamReportDetailPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/otherReports',
      component: lazyRouteComponent(
        () => import('./MyTeamOtherReportsPage'),
        'MyTeamOtherReportsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/finalReport',
      component: lazyRouteComponent(
        () => import('./MyTeamFinalReportPage'),
        'MyTeamFinalReportPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/sightings',
      component: lazyRouteComponent(
        () => import('./MyTeamSightingsPage'),
        'MyTeamSightingsPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/observations',
      component: lazyRouteComponent(() => import('./MyTeamAlgobsPage'), 'MyTeamAlgobsPage'),
    }),
    createRoute({
      getParentRoute: () => parent,
      // More specific path than `/my-team/observations/$reportId` — must be first.
      path: '/my-team/observations/report',
      component: lazyRouteComponent(() => import('./MyTeamAlgobsFormPage'), 'MyTeamAlgobsFormPage'),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/observations/$reportId/edit',
      component: lazyRouteComponent(() => import('./MyTeamAlgobsFormPage'), 'MyTeamAlgobsFormPage'),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/observations/$reportId',
      component: lazyRouteComponent(() => import('./MyTeamAlgobsDayPage'), 'MyTeamAlgobsDayPage'),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/my-team/official-reports',
      component: lazyRouteComponent(
        () => import('./MyTeamOfficialReportsPage'),
        'MyTeamOfficialReportsPage',
      ),
    }),
  ]
}
